<template>
  <div>
    <template v-if="$route.name === 'secretKeyLook'">
      <ots-main-title></ots-main-title>
      <div class="ots-title">
        <p>考试批次：{{ listName.planName }}</p>
        <p>考点：{{ listName.placeName }}</p>
        <p>场次名称：{{ listName.sessionName }}</p>
      </div>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
        @search="search"
      ></ots-table-group-new>
    </template>
    <template v-else></template>
  </div>
</template>
<script>
import { getPlanSite } from "@/http/modules/examSet/section";
import { queryEnterKeyDetailListAPI } from "@/http/modules/computedRoomExam";
export default {
  data() {
    return {
      listName: "",
      selectList: [
        {
          title: "教室",
          type: "select",
          isSearch: true,
          requestKey: "classId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
      ],
      tableData:[],
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
      ],
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "场次名称",
          prop: "sessionName",
        },
        {
          title: "教室",
          prop: "className",
        },
        {
          title: "进场秘钥",
          prop: "enterKey",
        },
      ],
      pagination: {
        total: 0,
      },
      requestForm: {
        classId: "",
        size: 10,
        page: 1,
      },
    };
  },
  mounted() {
    this.initDate();
  },
  created() {
    let lookclasslist = JSON.parse(window.localStorage.getItem("lookSecretKey"));
    this.listName = { ...lookclasslist }
  },
  watch:{
    "requestForm.classId":'search'
  },
  methods: {
    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },
    getTableData() {
      let params = {
        sessionId: this.listName.sessionId,
        planId: this.listName.planId,
        placeId: this.listName.placeId,
      };
      let param = {...params, ...this.requestForm}
      queryEnterKeyDetailListAPI(param).then((res) => {
        if(res.code == 1){
          this.pagination.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    async initDate(){
      const { data } = await getPlanSite({ planId: this.listName.planId });
      let session = data.filter((item)=> this.listName.placeId ==item.id)
      let sessionList = [{ id: "", name: "全部" }, ...session[0].placeClassList];
      this.$set(this.selectList[0], "data", sessionList);
      this.search()
    },
    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },
    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },

  },

};
</script>
<style lang="less" scoped>
.ots-title {
  display: flex;
  justify-content: space-between;
  background: #fff;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  margin-bottom:20px ;
}
</style>